import axios from '@axios'

export default {
  getRolesList(page, field) {
    return axios.post(`roles/list?page=${page}`, field)
  },
}
